module.exports = __webpack_public_path__ + "static/turin-0b2e451ce9a1f330b896c75fd57be5ea.jpeg";